import { formatISO } from "date-fns";
import { toZonedTime, fromZonedTime } from "date-fns-tz";
import { DateTime } from 'luxon';


export type DateMutation = {
  add?: {
    days?: number;
    weeks?: number;
    months?: number;
    years?: number;
  }
  sub?: {
    days?: number;
    weeks?: number;
    months?: number;
    years?: number;
  }
  time?: string;
}

export const getYesterday = (tz: string): DateTime => {
  return DateTime.now().setZone(tz).minus({ days: 1 }).startOf('day');
}

export const getToday = (tz: string): DateTime => {
  return DateTime.now().setZone(tz).startOf('day');
}

export const localizeDateTime = (dateTime: string, timeZone: string) => {
  const localizedDateTime = formatISO(toZonedTime(dateTime, timeZone));

  if (!localizedDateTime.endsWith("Z")) {
    const zeroedLocalizedDateTime = localizedDateTime.slice(0, -6);

    return `${zeroedLocalizedDateTime}Z`;
  }

  return localizedDateTime;
}

export const setTimeAndLocalizedDate = (baseDate: Date, timeZone: string, time: string) => {
  const year = baseDate.getFullYear();
  const month = String(baseDate.getMonth() + 1).padStart(2, '0');
  const day = String(baseDate.getDate()).padStart(2, '0');

  const localDateTimeString = `${year}-${month}-${day} ${time}`;

  const utcDate = fromZonedTime(localDateTimeString, timeZone);

  return utcDate.toISOString();
};

// TODO: DD - get rid of luxton
export const mutateDate = (date: DateTime, mutation?: DateMutation): DateTime => {
  let dt = date;
  if (mutation?.add) {
    dt = dt.plus({
      days: mutation.add.days ?? 0,
      weeks: mutation.add.weeks ?? 0,
      months: mutation.add.months ?? 0,
      years: mutation.add.years ?? 0,
    });
  }
  if (mutation?.sub) {
    dt = dt.minus({
      days: mutation.sub.days ?? 0,
      weeks: mutation.sub.weeks ?? 0,
      months: mutation.sub.months ?? 0,
      years: mutation.sub.years ?? 0,
    });
  }
  return dt;
}
